export const mockMeta = {
  mode: "mock",
  label: "Demo data",
  updatedAt: new Date().toISOString(),
  source: "Absolluty mock fixtures",
};

export const mockCameraImage =
  "https://images.unsplash.com/photo-1604719312566-8912e9227c6a?auto=format&fit=crop&w=1200&q=80";

export const mockDashboard = {
  kpis: {
    thefts_detected: 28,
    avoided_losses: 1840000,
    false_alarms: 6,
    cameras_online: 14,
    cameras_total: 16,
    critical_open: 3,
    people_today: 4287,
  },
  detection_types: [
    { id: "shoplifting", value: 28 },
    { id: "queue", value: 64 },
    { id: "person", value: 186 },
    { id: "dwell", value: 42 },
    { id: "fall", value: 3 },
  ],
  timeline: [
    { x: "09:00", y: 140 },
    { x: "11:00", y: 310 },
    { x: "13:00", y: 520 },
    { x: "15:00", y: 690 },
    { x: "17:00", y: 840 },
    { x: "19:00", y: 730 },
    { x: "21:00", y: 420 },
  ],
  camera_activity: [
    { id: "Entrada", value: 86 },
    { id: "Perfumeria", value: 121 },
    { id: "Cajas", value: 74 },
    { id: "Electronica", value: 97 },
    { id: "Salida", value: 65 },
  ],
  recent_alerts: [
    { id: "MCK-1", detection_type: "shoplifting", camera_display_name: "Perfumeria CAM-04", occurred_at: "2026-09-15T18:13:20-03:00", severity: "HIGH" },
    { id: "MCK-2", detection_type: "queue", camera_display_name: "Cajas CAM-06", occurred_at: "2026-09-15T17:58:10-03:00", severity: "MEDIUM" },
    { id: "MCK-3", detection_type: "dwell", camera_display_name: "Electronica CAM-07", occurred_at: "2026-09-15T17:31:40-03:00", severity: "MEDIUM" },
  ],
  liveCameras: [
    { id: "CAM-01", name: "CAM-01", display_name: "Entrada principal", branch_name: "Store 04", zone_name: "Entrada", status: "online", snapshot_url: mockCameraImage },
    { id: "CAM-04", name: "CAM-04", display_name: "Perfumeria", branch_name: "Store 04", zone_name: "Perfumeria", status: "online", snapshot_url: "https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=1200&q=80" },
    { id: "CAM-06", name: "CAM-06", display_name: "Cajas", branch_name: "Store 04", zone_name: "Cajas", status: "online", snapshot_url: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=1200&q=80" },
    { id: "CAM-07", name: "CAM-07", display_name: "Electronica", branch_name: "Store 04", zone_name: "Electronica", status: "degraded", snapshot_url: "https://images.unsplash.com/photo-1567958451986-2de427a4a0be?auto=format&fit=crop&w=1200&q=80" },
  ],
  aiStreams: [
    { camera_id: "CAM-04", ai_output_url: "mock://ai/perfumeria", snapshot_url: "https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=1200&q=80" },
    { camera_id: "CAM-07", ai_output_url: "mock://ai/electronica", snapshot_url: "https://images.unsplash.com/photo-1567958451986-2de427a4a0be?auto=format&fit=crop&w=1200&q=80" },
  ],
};

export const mockMapCameras = [
  { id: "CAM-01", x: "12%", y: "18%", status: "online", label: "Entrada" },
  { id: "CAM-02", x: "22%", y: "78%", status: "online", label: "Salida" },
  { id: "CAM-03", x: "42%", y: "48%", status: "online", label: "Pasillo central" },
  { id: "CAM-04", x: "58%", y: "32%", status: "online", label: "Perfumeria" },
  { id: "CAM-06", x: "66%", y: "72%", status: "online", label: "Cajas" },
  { id: "CAM-07", x: "36%", y: "64%", status: "degraded", label: "Electronica" },
  { id: "CAM-10", x: "82%", y: "72%", status: "offline", label: "Deposito" },
];

export const mockRiskScores = [
  {
    scope: "Store 04",
    score: 73,
    trend: "+8",
    dataMode: "mock",
    factors: ["Perfumeria con mayor recurrencia", "2 camaras offline", "Pico de alertas 18:00-20:00"],
  },
  {
    scope: "Store 12",
    score: 58,
    trend: "-4",
    dataMode: "mock",
    factors: ["Menos falsas alarmas", "Cobertura estable", "Tráfico normal"],
  },
  {
    scope: "Store 02",
    score: 41,
    trend: "0",
    dataMode: "mock",
    factors: ["Riesgo estable", "Sin incidentes críticos", "Camaras online"],
  },
];

export const mockIncidents = [
  {
    id: "INC-7421",
    storeId: "store-04",
    severity: "HIGH",
    status: "Reviewing",
    riskScore: 86,
    events: 5,
    cameras: 3,
    startedAt: "2026-09-15T18:12:00-03:00",
    duration: "4m 32s",
    title: "Persona #7421 - comportamiento sospechoso",
    zone: "Perfumeria",
  },
  {
    id: "INC-7398",
    storeId: "store-01",
    severity: "MEDIUM",
    status: "New",
    riskScore: 64,
    events: 3,
    cameras: 2,
    startedAt: "2026-09-15T16:44:00-03:00",
    duration: "2m 10s",
    title: "Permanencia prolongada en electronica",
    zone: "Electronica",
  },
];

export const mockIncidentTimeline = [
  { time: "18:12", label: "Persona detectada", camera: "CAM-04", confidence: 0.91 },
  { time: "18:13", label: "Interaccion con producto", camera: "CAM-04", confidence: 0.87 },
  { time: "18:14", label: "Evento sospechoso", camera: "CAM-07", confidence: 0.82 },
  { time: "18:15", label: "Cambio de camara", camera: "CAM-08", confidence: 0.78 },
  { time: "18:16", label: "Acercamiento a salida", camera: "CAM-02", confidence: 0.74 },
];

export const mockEvidence = [
  {
    id: "EVD-10029",
    incidentId: "INC-7421",
    cameraId: "CAM-04",
    type: "video",
    timestamp: "2026-09-15T18:13:20-03:00",
    source: "Demo evidence pack",
    dataMode: "mock",
    store: "Store 04",
    confidence: 0.87,
  },
  {
    id: "EVD-10030",
    incidentId: "INC-7421",
    cameraId: "CAM-07",
    type: "thumbnail",
    timestamp: "2026-09-15T18:14:02-03:00",
    source: "Demo evidence pack",
    dataMode: "mock",
    store: "Store 04",
    confidence: 0.82,
  },
];

export const mockHeatmapZones = [
  { zone: "Entrada", camera: "CAM-01", traffic: 92, alerts: 12, theft: 4, dwell: 44, risk: 68 },
  { zone: "Perfumeria", camera: "CAM-04", traffic: 64, alerts: 21, theft: 8, dwell: 82, risk: 86 },
  { zone: "Cajas", camera: "CAM-06", traffic: 88, alerts: 9, theft: 2, dwell: 51, risk: 58 },
  { zone: "Electronica", camera: "CAM-07", traffic: 48, alerts: 14, theft: 5, dwell: 77, risk: 72 },
  { zone: "Pasillo central", camera: "CAM-03", traffic: 76, alerts: 7, theft: 1, dwell: 36, risk: 42 },
  { zone: "Salida", camera: "CAM-02", traffic: 71, alerts: 16, theft: 6, dwell: 29, risk: 74 },
];

export const mockCameraHealth = [
  { id: "CAM-01", name: "Entrada", status: "online", fps: 24, latencyMs: 120, bitrate: "3.2 Mbps", droppedFrames: 2, uptime: "99.1%", aiState: "processing" },
  { id: "CAM-04", name: "Perfumeria", status: "online", fps: 20, latencyMs: 180, bitrate: "2.8 Mbps", droppedFrames: 8, uptime: "97.4%", aiState: "processing" },
  { id: "CAM-07", name: "Electronica", status: "degraded", fps: 12, latencyMs: 440, bitrate: "1.9 Mbps", droppedFrames: 31, uptime: "91.2%", aiState: "delayed" },
  { id: "CAM-10", name: "Deposito", status: "offline", fps: 0, latencyMs: 0, bitrate: "-", droppedFrames: 0, uptime: "88.0%", aiState: "stopped" },
];

export const mockForensicResults = [
  { id: "FS-1", title: "Persona con prenda roja", camera: "CAM-04", time: "18:18", confidence: 0.81, zone: "Perfumeria" },
  { id: "FS-2", title: "Evento similar a INC-7421", camera: "CAM-07", time: "18:22", confidence: 0.76, zone: "Electronica" },
  { id: "FS-3", title: "Permanencia mayor a 10 minutos", camera: "CAM-03", time: "17:49", confidence: 0.69, zone: "Pasillo central" },
];
